document.addEventListener("DOMContentLoaded", function() { 

  const checkIcon = `<svg focusable="false" width="32" height="14" class="icon icon--check filter-icon" viewBox="0 0 32 32">
    <path d="M24.59 8L12.9885 20.6731L7.31806 15.1819L6 16.6956L12.3755 22.8792L13.0805 23.5556L13.7395 22.8309L26 9.43318L24.59 8Z" stroke="currentColor">
    </path>
  </svg>`

  const events = [ ...document.querySelectorAll( '.event' ) ].map( el => {
    if ( !el.dataset.date ) { el.remove(); return null; }
    const category = el.dataset.category ?? null;
    const date = new Date( el.dataset.date );
    const period = el.dataset.period;

    return { el, date, period, category};
  } ).filter( Boolean );
  events.sort( (a, b) => a.date.getTime() > b.date.getTime() ? 1 : -1 );
  events.forEach( (event, index) => event.el.style.order = index );

  let categoryFilter = null, periodFilter = null;

  const emptyStateMessage = document.querySelector('.empty-state');

  function updateEvents() {
    let visibleElements = 0;
    events.forEach( event => {
      const visible = isVisible(event);
      event.el.classList.toggle( 'hidden', !visible);
      if(visible) visibleElements++;
    });

    emptyStateMessage.classList.toggle('hidden', visibleElements > 0);

  }

  updateEvents();

  function isVisible(event) {
  if (categoryFilter === null && periodFilter === null) return true;
  if (categoryFilter !== null && event.category !== categoryFilter) return false;
  if (periodFilter !== null) {
    // Se il filtro è un anno (4 cifre), confronta con l'anno della data
    const isYearFilter = /^\d{4}$/.test(periodFilter);
    if (isYearFilter) {
      if (event.date.getFullYear().toString() !== periodFilter) return false;
    } else {
      if (event.period !== periodFilter) return false;
    }
  }
  return true;
}

  initializeCategoryFilter();
  initializePeriodFilter();

  function createOption(selectId, label, value = label){

    return `<label class="popover__choice-item">
              <input type="radio" data-bind-value="${selectId}-value" class="visually-hidden" name="${selectId}-filter" value="${value}" title="${label}"/>
              <span>${label}</span>
            </label>`;
  }

  function resetHover(container){
    const filterElement = container.querySelectorAll('.popover__choice-item');
    filterElement.forEach(el => el.classList.remove('active-filter'));
  }

  function initializePeriodFilter(){
  // Cerca prima #month, poi #year (archivio)
  const periodFilterEl = document.querySelector('#month') || document.querySelector('#year');
  if (!periodFilterEl) return;

  const isYearMode = periodFilterEl.id === 'year';
  const periodContainer = periodFilterEl.querySelector('.popover__choice-list');
  const defaultPeriod = periodFilterEl.dataset.allOptions;

  let distinctPeriods;

  if (isYearMode) {
    // Estrai anno da data-date e ordina decrescente
    const years = [...new Set(events.map(e => e.date.getFullYear().toString()))].sort((a, b) => b - a);
    distinctPeriods = [defaultPeriod, ...years];
  } else {
    distinctPeriods = [...new Set([defaultPeriod, ...events.map(e => e.period).filter(Boolean)])];
  }

  distinctPeriods.forEach(cat => periodContainer.insertAdjacentHTML('beforeend', createOption('period', cat)));

  const defaultOption = periodContainer.querySelector('.popover__choice-item');
  defaultOption.classList.add('active-filter');

  periodFilterEl.addEventListener('click', e => {
    if (!e.target.value) return;

    resetHover(periodContainer);
    periodFilter = e.target.value === defaultPeriod ? null : e.target.value;
    e.target.closest('.popover__choice-item').classList.add('active-filter');
    periodFilterEl.open = false;
    updateEvents();
  });
}


  function initializeCategoryFilter() {
    const categoryFilterEl = document.querySelector('#category');
    const categoryContainer = categoryFilterEl.querySelector('.popover__choice-list');
    const defaultCategory = categoryFilterEl.dataset.allOptions;

    const distinctCategory = new Set( [ defaultCategory, ...events.map( e => e.category).filter( Boolean) ] );
    distinctCategory.forEach( cat => categoryContainer.insertAdjacentHTML( 'beforeend', createOption('category', cat ) ) );

    const defaultOption = categoryContainer.querySelector('.popover__choice-item');
    defaultOption.classList.add('active-filter');

    categoryFilterEl.addEventListener( 'click', e => {
      if(!e.target.value) {
        return;
      }
      resetHover(categoryContainer);
      categoryFilter = e.target.value === defaultCategory ? null : e.target.value;
      e.target.closest('.popover__choice-item').classList.add('active-filter');
      categoryFilterEl.open = false;
      updateEvents();
    } );
  }

  const selectionOption = document.querySelectorAll('.popover__choice-item');
  selectionOption.forEach(el => el.insertAdjacentHTML('beforeend',checkIcon));

});
